import BaseApp from "./Base";


export default function BlankComp(){

    return(
        <BaseApp
        title="Blank Page"
        searchDisplay="Block"
        dropdownDisplay="Block">
        </BaseApp>
    );
}